var _path, _path2, _path3, _path4, _path5, _mask, _path6, _path7, _circle, _circle2, _circle3, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictographic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "26.25 0.12 259.63 171.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.525 167V82.349c21.267-22.178 65.666-68.587 73.126-76.81 7.46-8.221 15.542-3.425 18.65 0l71.654 76.81v84.658a3.994 3.994 0 0 1-4 3.993H65.525a4 4 0 0 1-4-4",
    fill: "#D1D8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.525 82.349V167a4 4 0 0 0 4 4h155.43c2.209 0 4-1.784 4-3.993V82.349m-163.43 0c21.267-22.178 65.666-68.587 73.126-76.81 7.46-8.221 15.542-3.425 18.65 0l71.654 76.81m-163.43 0 81.96 42.731 81.47-42.731",
    stroke: "#221302",
    strokeWidth: 1.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.831 28.317c-30.504-.158-95.44-.348-112.245-.084-2.096.033-3.705 1.727-3.705 3.823l-.002 61.03 59.952 31.924 59.951-31.387V32.291c0-2.2-1.751-3.962-3.951-3.974",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.831 28.317c-30.504-.158-95.44-.348-112.245-.084-2.096.033-3.705 1.727-3.705 3.823l-.002 61.03 59.952 31.924 59.951-31.387V32.291c0-2.2-1.751-3.962-3.951-3.974Z",
    stroke: "#221302",
    strokeWidth: 1.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.244 66h61m-61 11h46",
    stroke: "#221302",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 3.54a2 2 0 0 0-2 2v41.553a2 2 0 0 0 2 2h41.352L77.685 60l6.334-10.907H93a2 2 0 0 0 2-2V5.539a2 2 0 0 0-2-2z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 3.54a2 2 0 0 0-2 2v41.553a2 2 0 0 0 2 2h41.352L77.685 60l6.334-10.907H93a2 2 0 0 0 2-2V5.539a2 2 0 0 0-2-2z",
    fill: "#F4A226"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m71.352 49.093 1.513-.88-.505-.87h-1.008zM77.685 60l-1.513.879 1.513 2.606 1.514-2.606zm6.334-10.907v-1.75H83.01l-.506.87zM29.75 5.539a.25.25 0 0 1 .25-.25v-3.5a3.75 3.75 0 0 0-3.75 3.75zm0 41.554V5.539h-3.5v41.554zm.25.25a.25.25 0 0 1-.25-.25h-3.5a3.75 3.75 0 0 0 3.75 3.75zm41.352 0H30v3.5h41.352zM79.2 59.12l-6.334-10.907-3.026 1.757 6.333 10.908zm3.306-10.907L76.172 59.12l3.027 1.758 6.333-10.908zM93 47.343h-8.981v3.5H93zm.25-.25a.25.25 0 0 1-.25.25v3.5a3.75 3.75 0 0 0 3.75-3.75zm0-41.554v41.554h3.5V5.539zM93 5.29a.25.25 0 0 1 .25.25h3.5A3.75 3.75 0 0 0 93 1.79zm-63 0h63v-3.5H30z",
    fill: "#000",
    mask: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.691,
    cy: 26.5,
    r: 3.265,
    fill: "#F4A226",
    stroke: "#000",
    strokeWidth: 1.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.254,
    cy: 26.5,
    r: 3.265,
    fill: "#F4A226",
    stroke: "#000",
    strokeWidth: 1.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.062,
    cy: 26.5,
    r: 3.265,
    fill: "#F4A226",
    stroke: "#000",
    strokeWidth: 1.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.986 124.897 192 111.802 285 107l-46.061 55-11.567-22.698-19.58 2.619z",
    fill: "#FFF392"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.986 124.897 192 111.802 285 107m-75.014 17.897-2.194 17.024m2.194-17.024L285 107m-77.208 34.921 15.354-10.913m-15.354 10.913 19.58-2.619m-4.226-8.294L285 107m-61.854 24.008 4.226 8.294M285 107l-46.061 55-11.567-22.698",
    stroke: "#000",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictographic);
export default __webpack_public_path__ + "static/media/pictographic.1479c484f6f24b16eeee97b3253d774d.svg";
export { ForwardRef as ReactComponent };